import * as React from 'react'
import { styled } from '../../../../shared/styled-components'
import { NewOfficeItem } from './NewOfficeItem'
import { OfficeInstance } from '../../../../models/Office'
import { Loading } from '../../../../shared/components/Loading'

interface IProps {
  loading?: boolean
  offices: OfficeInstance[]
  trackingSource?: string
  onVideoClick?: (office: OfficeInstance) => any
}

export const NewOfficeList = ({ loading, offices, trackingSource, onVideoClick }: IProps) => {
  return (
    <List>
      {offices.map((office) => (
        <NewOfficeItem
          {...{ office, trackingSource }}
          key={office.id}
          onVideoClick={onVideoClick?.bind(null, office)}
        />
      ))}
      {!loading && offices.length === 0 && <NoItemsText>Leider konnten keine Praxen gefunden werden.</NoItemsText>}
      {loading && <Loading />}
    </List>
  )
}

const List = styled.ul`
  list-style: none;
  @media (max-width: 600px) {
    background-color: ${(props) => props.theme.blueColor};;
    padding: 10px
    border-radius: 10px;
    margin: 0 10px;
    }
`

const NoItemsText = styled.div`
  text-align: center;
`
